import {Button, Card, Form, notification, Select, Spin} from 'antd';
import React from "react";
import {getFormFieldByType, sanitizeFieldName} from "../../util/methods";
import DocumentList from "../../components/DocumentList";

import moment from 'moment';
import Assets from "./assets";

class Create extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disableCreate: false,
      documentData: [],
      suspendedDocumentData: [],
    };
  }

  componentDidMount() {
    const {match, getAll} = this.props;
    getAll();
  }

  getDocumentData = (data) => {
    this.setState({documentData: data});
  };

  getSuspendedDocumentData = (data) => {
    this.setState({suspendedDocumentData: data})
  };

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if(err) {
        return console.log(err);
      }

      let errors = [];

      const data = Object.assign({}, values);

      if(data.assets && data.assets.length > 0) {

        data.assets = data.assets.map(assetData => {
          let asset = null;
          if(assetData.leasingAsset && assetData.location && assetData.periodFrom && assetData.periodTo) {
            asset = {
              id: this.ObjectId(),
              leasingAsset: assetData.leasingAsset,
              location: assetData.location,
              periodFrom: moment(assetData.periodFrom).format('YYYY-MM-DD'),
              periodTo: moment(assetData.periodTo).format('YYYY-MM-DD'),
              lockInPeriodFrom: moment(assetData.lockInPeriodFrom).format('YYYY-MM-DD'),
              lockInPeriodTo: moment(assetData.lockInPeriodTo).format('YYYY-MM-DD'),
              residualAmount: assetData.residualAmount ? assetData.residualAmount : 0,
            };
          } else {
            errors.push('Asset Data missing!');
          }

          if(assetData.leaseAmount && assetData.leaseAmount.length > 0) {
            asset.leaseAmount = assetData.leaseAmount.map(amount => {
                return {
                  id: this.ObjectId(),
                  wef: moment(amount.wef).format('YYYY-MM-DD'),
                  amount: amount.amount
                }
              }
            )
          } else {
            errors.push('Asset amount missing!');
          }

          if(assetData.suspensionInfo && assetData.suspensionInfo.length > 0) {
            asset.suspensionInfo = assetData.suspensionInfo.map(suspend => {
                return {
                  id: this.ObjectId(),
                  suspensionFrom: suspend.suspensionFrom,
                  suspensionTo: suspend.suspensionTo,
                  // suspensionDocuments: suspend.suspensionDocuments,
                  suspensionDescription: suspend.suspensionDescription,
                }
              }
            )
          }
          return asset;
        });
      } else {
        new Error('No Asset found!')
      }

      const {
        documentData
      } = this.state;
      if(documentData.length === 0) {
        data.documents = this.props && this.props.data && this.props.data.documents;
      } else {
        data.documents = documentData;
      }
      data.documents = documentData;

      if(errors && errors.length === 0) {
        if(match.params && match.params.id) {
          this.props.onSubmit(data, match.params.id);
        } else {
          this.props.onSubmit(data);
        }
      } else {
        this.openErrorNotification(errors);
      }

    });
  }

  openErrorNotification = errors => {
    notification['error']({
      message: 'Data missing!',
      description: errors.map((txt, i) => (<div key={i}>{txt}</div>))
    });
  };

  ObjectId = (m = Math, d = Date, h = 16, s = s => m.floor(s).toString(h)) =>
    s(d.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(m.random() * h));

  toggleDisableCreate = (isDisable) => {
    this.setState({
      disableCreate: isDisable
    })
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, edit, loading, filters, title, resource, subDocumentFilters, form} = this.props;
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item) => {
              if(filters[item].type === 'Array' && filters[item].schema) {

                return <Assets key={item} item={filters[item]} form={form} data={data && data[item]}
                               title={title} docData={this.state.documentData}
                               disableCreateBtn={this.toggleDisableCreate}
                               resource={resource} assetSearch={this.props.assetSearch}
                               assetData={this.props.assetData} {...this.props}/>

              } else if(filters[item].type === 'Array' && item === 'documents') {
                return <DocumentList match={this.props.match} history={this.props.history}
                                     key={item} item={filters[item]} form={form} data={data[item]}
                                     subDocumentFilters={subDocumentFilters}
                                     getDocumentData={this.getDocumentData}/>
              } else if(filters[item] && filters[item].options && filters[item].options.hidden) {
                return;
              } else if(item === 'nextContract' || item === 'prevContract') {
                const dataKey = item.split('.')[1] ? item.split('.')[1] : item;
                const dataKeyObj = item.split('.')[1] ? item.split('.')[0] : null;
                const value = data && data[dataKeyObj ? dataKeyObj : item] ? (dataKeyObj ? data[dataKeyObj][dataKey] : data[dataKey]) : null;
                return <Form.Item key={item} label={sanitizeFieldName(filters[item].options.label ?
                  filters[item].options.label : item)}>
                  {getFieldDecorator(item, {
                    rules: [{
                      required: filters[item].required,
                      message: `${sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)} is required!`
                    }],
                    initialValue: value && value._id,
                  })(<Select
                    showSearch
                    allowClear
                    mode="single"
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder="Please select"
                  >
                    {edit && edit.data && edit.data.map(con =>
                      <Select.Option key={con._id}
                                     value={con._id}>{`${con.id}`}</Select.Option>)}
                  </Select>)}

                </Form.Item>;
              } else {
                if(item !== 'isArchived')
                  return getFormFieldByType(filters, item, getFieldDecorator, data, {title: title, resource});
              }

              return null;

            })}

            <Form.Item>
              <Button disabled={this.state.disableCreate} type="primary" className="gx-mb-0" htmlType="submit"
                      loading={loading || this.props.contractUploading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
